import VuetifyNumberInput from '@jzolago/vuetify-number-input';
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Vue from 'vue'
import VModal from 'vue-js-modal';
import VueTheMask from 'vue-the-mask';
import App from './App.vue'
import Vuetify from 'vuetify';
import VueYandexMetrika from 'vue-yandex-metrika';
import VueAnimateOnScroll from 'vue-animate-onscroll';

import './filters/money';
import './filters/plural';

import './directives/scrollTo';
Vue.use(Vuetify);
Vue.use(VueTheMask);
Vue.use(VModal);
Vue.use(VuetifyNumberInput);
Vue.use(VueAnimateOnScroll);

Vue.use(VueYandexMetrika, {
  id: 99646105,
  env: "production",
  options: {
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
    webvisor: true,
  }
});

Vue.config.productionTip = false

new Vue({
  vuetify: new Vuetify(),
  render: h => h(App)
}).$mount('#app')
